'use strict';

angular.module('licensure.portal', [
    // angular modules
    'ui.router',
    'LocalStorageModule',
    'ui.bootstrap',
    'ngAnimate',
    'ngSignaturePad',
    'ngFileUpload',
    'ngIdle',
    'gRecaptcha.v3',

    // imagetrend modules
    'imagetrend.components',
    'licensure.helpers',
    'licensure.services',

    // portal modules
    'portal.applications',
    'portal.inspections',
    'portal.services',
    'portal.login',
    'portal.lookup',
    'portal.react',
    'portal.linkpage',
])
    .config([
        '$stateProvider',
        '$urlRouterProvider',
        '$httpProvider',
        'localStorageServiceProvider',
        //'$qProvider',
        '$locationProvider',
        function (
            $stateProvider,
            $urlRouterProvider,
            $httpProvider,
            localStorageServiceProvider,
            //$qProvider,
            $locationProvider
        ) {
            //$qProvider.errorOnUnhandledRejections(false); // this hides the first 4 errors that throw on each angularJs page load
            $locationProvider.hashPrefix(''); // otherwise starts as '!'

            $httpProvider.interceptors.push('ApiIntercepter');
            if (!$httpProvider.defaults.headers.get) {
                $httpProvider.defaults.headers.get = {};
            }
            $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
            $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            $urlRouterProvider.otherwise('/login');
            localStorageServiceProvider.setPrefix('licensure');

            $stateProvider
                // public routings
                .state('portal', {
                    abstract: true,
                    templateUrl: paths.app + 'components/portal/portal.html',
                    data: {
                        isPortal: true,
                        messages: []
                    },
                    controller: ['$scope', '$rootScope', 'CMSPages', function ($scope, $rootScope, CMSPages) {
                        $scope.site = $rootScope.site;
                        // buid an array of portal_pages indexed by state for easy access
                        $scope.portal_pages = [];
                        $scope.site.portal_pages.forEach(function (p) {
                            if ($scope.portal_pages[p.state] === undefined || $scope.portal_pages[p.state] == null) {
                                $scope.portal_pages[p.state] = p;
                            }
                        });
                        $rootScope.portal_pages = $scope.portal_pages;

                        // get the default cms page
                        $scope.page = CMSPages.get({ site_id: $scope.site.id, address: "" })
                    }],
                    resolve: {
                        userAccount: ['$rootScope', 'Account', function ($rootScope, Account) {
                            if ($rootScope.userAccount == null || $rootScope.userAccount == undefined) {
                                $rootScope.loadingUserAccount = true;
                                $rootScope.$state.current = this.self;
                                return Account.get({ portal: true }).then(function (account) {
                                    $rootScope.userAccount = account;
                                    $rootScope.loadingUserAccount = false;
                                });
                            }
                            else {
                                return $rootScope.userAccount;
                            }
                        }],

                        enterprise: ['$q', '$rootScope', '$location', 'Enterprise', 'CMSSites', 'gRecaptcha', function ($q, $rootScope, $location, Enterprise, CMSSites, gRecaptcha) {
                            var d = $q.defer();
                            if ($rootScope.enterprise === undefined || $rootScope.enterprise == null) {
                                var portalAbsUrl = $location.absUrl();
                                var portalUrl = $location.url();
                                portalUrl = portalAbsUrl.substring(0, portalAbsUrl.indexOf(portalUrl));
                                portalUrl = portalUrl.substring(0, portalUrl.lastIndexOf("/")+1);
                                $rootScope.loadingEnterprise = true;
                                $rootScope.$state.current = this.self;
                                if ($rootScope.enterpriseID === undefined || $rootScope.enterpriseID != null) {
                                    return Enterprise.getByAddress(portalUrl).then(function (enterprise) {
                                        if (enterprise != null) {
                                            $rootScope.enterprise = enterprise;
                                            $rootScope.enterpriseID = enterprise.id;
                                            $rootScope.loadingEnterprise = false;
                                            $rootScope.loadingSite = true;

                                            if (enterprise) {
                                                //Recaptcha
                                                if (enterprise.recaptcha_enabled) {
                                                    gRecaptcha.initialize({ key: enterprise.recaptcha_site_key_v3})
                                                }
                                            }

                                            var promise = CMSSites.getByEnterprise(enterprise.id).then(function (site2) {
                                                $rootScope.site = site2;
                                                $rootScope.loadingSite = false;
                                            });
                                            return $q.all([enterprise, promise]);
                                        }
                                    });
                                }
                                else {
                                    return Enterprise.get().then(function (enterprise) {
                                        if (enterprise != null) {
                                            $rootScope.enterprise = enterprise;
                                            $rootScope.loadingEnterprise = false;
                                            $rootScope.loadingSite = true;

                                            if (enterprise) {
                                                //Recaptcha
                                                if (enterprise.recaptcha_enabled) {
                                                    gRecaptcha.initialize({ key: enterprise.recaptcha_site_key_v3 })
                                                }
                                            }

                                            var promise = CMSSites.getByEnterprise(enterprise.id).then(function (site2) {
                                                $rootScope.site = site2;
                                                $rootScope.loadingSite = false;
                                            });
                                            return $q.all([enterprise, promise]);
                                        }
                                    });
                                }
                            }
                            else {
                                d.resolve($rootScope.enterprise);
                            }
                            return d.promise;
                        }],

                        site: ['$rootScope', 'CMSSites', function ($rootScope, CMSSites) {
                            if ($rootScope.site == null) {
                                $rootScope.loadingSite = true;
                                $rootScope.$state.current = this.self;
                                return CMSSites.get().then(function (site) {
                                    if (site != null) {
                                        $rootScope.site = site;
                                        $rootScope.loadingSite = false;
                                    }
                                    else {
                                        return CMSSites.getByEnterprise($rootScope.enterpriseID).then(function (site2) {
                                            $rootScope.site = site2;
                                            $rootScope.loadingSite = false;
                                        });
                                    }   
                                });
                            }
                            else {
                                return $rootScope.site;
                            }
                        }]
                    }
                })
                .state('portal.menus', {
                    abstract: true,
                    templateUrl: paths.app + "layouts/menus.html"
                })
                .state('portal.menus.denied', {
                    url: '/denied',
                    templateUrl: paths.app + "layouts/denied.html"
                })
        }])
    .run(['$rootScope', '$state', 'localStorageService', '$window', 'Session', 'Utils', function ($rootScope, $state, localStorageService, $window, Session, Utils) {
    $rootScope.now = new Date();

    $rootScope.offline = !navigator.onLine;
    const noTimeoutModalStates = ['portal.menus.login', 'portal.menus.createaccount', 'portal.menus.forgotusername', 'portal.menus.forgotpassword'];

    $window.addEventListener("offline", function () {
        $rootScope.$apply(function () {
            $rootScope.offline = true;
        });
    }, false);
    $window.addEventListener("online", function () {
        $rootScope.$apply(function () {
            $rootScope.offline = false;
        });
    }, false);
    document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === 'visible' && $rootScope.userAccount !== null && !noTimeoutModalStates.includes($state.current.name)) {
            //Check their session in case the user closes their computer, reopens and their session is expired
            Session.IsSessionAlive().then(function (session) {
                //If session is expired, log them out
                if (!session) {
                    Utils.DeleteSessionCookie(true);
                    Session.expireSession(true);
                    localStorageService.remove('portalAuthorizationData');
                    $rootScope.userAccount = null;
                    $state.go("portal.menus.login", { messages: ["You have successfully logged out"] });
                }
            }).catch(function (response) {
                // handle error
            });  
        }
    });  

    $rootScope.$state = $state;
    $rootScope.$on('$stateChangeStart', function (event, toState) {
        if (toState.resolve) {
            $rootScope.resolving = true;

            $rootScope.authenticatedPage = !noTimeoutModalStates.includes(toState.name);
        }
    });
    $rootScope.$on('$stateChangeSuccess', function (to, from, fromParams) {
        $rootScope.$state = $state;
        $rootScope.$state.from = from;
        $rootScope.$state.from.params = fromParams;
        Session.checkIn();
        if (to.resolve) {
            $rootScope.resolving = false;
        }

        //Close the mobile nav if needed
        var nav = angular.element(document.querySelector("#licensure .navigation"));
        if (nav.css('display') == 'block') {
            nav.css('display', 'none');
            var mobileTab = angular.element(document.querySelector("#licensure .menu.mobile"));
            if (mobileTab.hasClass('expand')) {
                mobileTab.removeClass('expand');
            }
        }
    });

        $rootScope.isStringSafe = function (string) {
            return !string.includes("<") && !string.includes(">");
        }
}]);